import {createReducer, on} from "@ngrx/store";
import {WorkingGroupsActions} from "../actions";
import type {
  WorkingGroupDetailDto,
  WorkingGroupPostDocumentDto,
  WorkingGroupPostDto,
  WorkingGroupRequestDto
} from "@esa/api";
import {EnumDetailDto, WorkingGroupDto} from "@esa/api";
import {WorkingGroupsStats} from "../../models/working-groups";

export const workingGroupsFeatureKey = 'workingGroups';

export interface WorkingGroupsState {
  workingGroups: WorkingGroupDto[];
  selectedWorkingGroup: WorkingGroupDetailDto;
  selectedWorkingGroupId: string;
  workingGroupTypes: EnumDetailDto[];
  workingGroupsStats: WorkingGroupsStats;
  selectedWorkingGroupPosts: WorkingGroupPostDto[];
  selectedWorkingGroupPostsCount: number;
  selectedWorkingGroupRequests: WorkingGroupRequestDto[],
  selectedWorkingGroupRequestId: string,
  selectedWorkingGroupPostDocuments: WorkingGroupPostDocumentDto[],
  totalDocuments: number
}

const initialState: WorkingGroupsState = {
  workingGroups: [],
  selectedWorkingGroup: null,
  selectedWorkingGroupId: '',
  workingGroupTypes: [],
  workingGroupsStats: {
    totalGroups: 0,
    totalMembers: 0,
    activeMembers: 0
  },
  selectedWorkingGroupPosts: [],
  selectedWorkingGroupPostsCount: 0,
  selectedWorkingGroupRequests: [],
  selectedWorkingGroupRequestId: '',
  selectedWorkingGroupPostDocuments: [],
  totalDocuments: 0
};

export const workingGroupsReducer = createReducer(
  initialState,
  on(WorkingGroupsActions.getWorkingGroups, (state) => ({ ...initialState })),
  on(WorkingGroupsActions.getWorkingGroupsSuccess, (state, { workingGroups, workingGroupsStats }) => ({
    ...state,
    workingGroups,
    workingGroupsStats,
    selectedWorkingGroupId: '',
    selectedWorkingGroup: null,
    selectedWorkingGroupPosts: [],
    selectedWorkingGroupPostsCount: 0,
    selectedWorkingGroupRequests: [],
    selectedWorkingGroupRequestId: '',
  })),
  on(WorkingGroupsActions.setSelectedWorkingGroupId, (state, { selectedWorkingGroupId }) => ({ ...state, selectedWorkingGroupId })),
  on(WorkingGroupsActions.getWorkingGroupByIdSuccess, (state, { selectedWorkingGroup }) => ({ ...state, selectedWorkingGroup })),
  on(WorkingGroupsActions.getWorkingGroupTypesSuccess, (state, { workingGroupTypes }) => ({ ...state, workingGroupTypes })),
  on(WorkingGroupsActions.updateWorkingGroupSuccess, (state) => ({ ...state, selectedWorkingGroup: null, selectedWorkingGroupId: '' })),
  on(WorkingGroupsActions.archiveWorkingGroupSuccess, (state) => ({ ...state, selectedWorkingGroup: null, selectedWorkingGroupId: '' })),
  on(WorkingGroupsActions.unarchiveWorkingGroupSuccess, (state) => ({ ...state, selectedWorkingGroup: null, selectedWorkingGroupId: '' })),
  on(WorkingGroupsActions.getSelectedWorkingGroupPostsSuccess, (state, { selectedWorkingGroupPosts, selectedWorkingGroupPostsCount }) => ({
    ...state,
    selectedWorkingGroupPosts,
    selectedWorkingGroupPostsCount
  })),
  on(WorkingGroupsActions.getSelectedWorkingGroupRequestsSuccess, (state, { selectedWorkingGroupRequests }) => ({
    ...state,
    selectedWorkingGroupRequests,
    selectedWorkingGroupRequestId: '',
  })),
  on(WorkingGroupsActions.setSelectedWorkingGroupRequestId, (state, { selectedWorkingGroupRequestId }) => ({ ...state, selectedWorkingGroupRequestId })),
  on(WorkingGroupsActions.setSelectedWorkingGroup, (state, { selectedWorkingGroup }) => ({ ...state, selectedWorkingGroup })),
  on(WorkingGroupsActions.getWorkingGroupPostDocumentsSuccess, (state, { selectedWorkingGroupPostDocuments, totalDocuments }) => ({
    ...state,
    selectedWorkingGroupPostDocuments,
    totalDocuments 
  })),
);
